import mapboxgl from 'mapbox-gl';
import React, { useState, useEffect, useRef }   from 'react';
import ReactMapboxGl, {
  Layer, Feature, Source, ZoomControl, ScaleControl, Popup, Marker
} from 'react-mapbox-gl';
import ApiInterface from '../lib/ApiInterface.js';
import {COUNTRY_COLORS} from '../lib/Const.js'
import ReactLoading from 'react-loading';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const popupHeader: React.CSSProperties = {
  color: 'black',
  textAlign: 'center'
};

const popupBody: React.CSSProperties = {
  color: 'black'
};

const Map = ReactMapboxGl({
  accessToken:
    'pk.eyJ1Ijoid3RnZW9ncmFwaGVyIiwiYSI6ImNrNXk3dXh6NzAwbncza3A1eHlpY2J2bmoifQ.JRy79QqtwUTYHK7dFUYy5g',
  maxZoom: 16
});

const raceLabels = {
  'PCT_P0020002': 'Hispanic or Latino Population',
  'PCT_P0020005': 'White Alone',
  'PCT_P0020006': 'Black or African American alone',
  'PCT_P0020007': 'American Indian and Alaska Native alone',
  'PCT_P0020008': 'Asian Alone',
  'PCT_P0020009': 'Native Hawaiian and Other Pacific Islander',
  'PCT_P0020010': 'Some Other Race',
  'PCT_P0020011': 'Population of two or more races'
}

const pointInPolygon = require('point-in-polygon');

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

function MapContainer(props) {
  const [option, setOption] = useState({
    "type": "vector",
    "tiles": ['http://localhost:8000/tiles/{z}/{x}/{y}.pbf', ],
    'minzoom': 6,
    'maxzoom': 14
  });
  const SERVRITY = {
    "1": "property",
    "2": "society",
    "3": "person-property",
    "5": "person",
    "4": "simple-assault"
  }
  const [state, setState] = useState({});
  const [center, setCenter] = useState([-90.38277827426225, 37.71859032558816]);
  const [zoom, setZoom] = useState([4]);
  const [showPopup, setShowPopup] = useState(false);
  const [popPoint, setPopPoint] = useState([-90.38277827426225, 37.71859032558816]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMarker, setIsMarker] = useState(false);
  const [currZoom, setCurrZoom] = useState(4);
  const markerUrl = 'https://peoplemaps.us/mapsdata/static/marker-large.svg'
  const mapRef = useRef(null);
  const [slide, setSlide] = useState(true);

  useEffect(() => {
    setState(props.state)
    console.log(props.state)
    setShowPopup(false)

    if (mapRef?.current?.state?.map) {
      const map = mapRef?.current?.state?.map
      map.zoomTo(map.getZoom());
    }
  }, [props.state]);

  useEffect(() => {
    setIsMarker(props.isMarker)
  }, [props.isMarker]);

  useEffect(() => {
    if (props.region) {
      // setCenter(props.region.center)
      // setIsMarker(true)

      // if(props.region.place_type.includes('region') || props.region.place_type.includes('place')) {
      //   setZoom([12])
      // } else {
      //   setZoom([14])
      // }
    }
  }, [props.region]);

  const onClickMap = (map, evt) => {
    let api = new ApiInterface();
    const zoom = map.getZoom()
    setCurrZoom(zoom)
    let data = {
      'lat': evt.lngLat.lat,
      'lng': evt.lngLat.lng
    }

    setShowPopup(false);
    if (document.getElementById('race') && zoom >= 13 && zoom <= 17) {
      let data = map.querySourceFeatures("racedata");
      let pt = [evt.lngLat.lng, evt.lngLat.lat]
      // setShowPopup(true);
      setPopPoint([evt.lngLat.lng, evt.lngLat.lat])
      console.log(data, pt)

      data.forEach(feature => {
        if (pointInPolygon(pt, feature.geometry.coordinates[0]) && feature.properties['max']) {
          setShowPopup(true);
          setData(feature.properties)
        }
      })
    } else if (document.getElementById('income') && zoom >= 10 && zoom <= 17) {
      let data = map.querySourceFeatures("income");
      let pt = [evt.lngLat.lng, evt.lngLat.lat]
      // setShowPopup(true);
      setPopPoint([evt.lngLat.lng, evt.lngLat.lat])
      console.log(data, pt)

      data.forEach(feature => {
        if (pointInPolygon(pt, feature.geometry.coordinates[0]) && feature.properties['B19049_001E']) {
          setShowPopup(true);
          setData(feature.properties)
        }
      })
    } else if (document.getElementById('occupancy') && zoom >= 10 && zoom <= 17) {
      let data = map.querySourceFeatures("occupancy");
      let pt = [evt.lngLat.lng, evt.lngLat.lat]
      // setShowPopup(true);
      setPopPoint([evt.lngLat.lng, evt.lngLat.lat])
      console.log(pt)

      data.forEach(feature => {
        feature.geometry.coordinates.map(coord => {
          if (feature.geometry.coordinates.length > 1) {
            coord = coord[0]
          }

          if (pointInPolygon(pt, coord)) {
            console.log(pt, feature)
            setShowPopup(true);
            setData(feature.properties)
          }
        })
      })
    } else if (document.getElementById('voting')) {
      setData([])
      setLoading(true)
      api.call('api/get-voting-data/', data, function(res){
        setLoading(false)
        if (res.data) {
          setShowPopup(true);
          setPopPoint([evt.lngLat.lng, evt.lngLat.lat])
          // setCenter([parseFloat(res.data[14]), parseFloat(res.data[13])])
          // setZoom([16])
          setData(res.data)
        }
      })
    } else if (document.getElementById('crime')) {
      setData([])
      setLoading(true)
      api.call('api/get-crime-data/', data, function(res){
        setLoading(false)
        if (res.data) {
          setShowPopup(true);
          setPopPoint([parseFloat(res.data[14]), parseFloat(res.data[13])])
          // setCenter([parseFloat(res.data[14]), parseFloat(res.data[13])])
          // setZoom([16])
          setData(res.data)
        }
      })
    } else if (document.getElementById('ancestry')) {
      setData([])
      setLoading(true)
      api.call('api/get-ancestry-data/', data, function(res){
        setLoading(false)
        if (res.data) {
          setShowPopup(true);
          setPopPoint([evt.lngLat.lng, evt.lngLat.lat])
          // setCenter([parseFloat(res.data[14]), parseFloat(res.data[13])])
          // setZoom([16])
          setData(res.data)
        }
      })
    }  
  }

  const updateData = (map, bbox) => {
    let api = new ApiInterface();
    api.arcgis('https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Census_2020_Redistricting_Blocks/FeatureServer/0/query?where=&geometryType=esriGeometryEnvelope&inSR=4326&spatialRel=esriSpatialRelIntersects&outFields=PCT_P0020007%2C+PCT_P0020008%2C+PCT_P0020006%2C+PCT_P0020002%2C+PCT_P0020009%2C+PCT_P0020010%2C+PCT_P0020011%2C+PCT_P0020005&returnGeometry=true&f=pgeojson', {
      geometry: `${bbox[0][0]}, ${bbox[0][1]}, ${bbox[1][0]}, ${bbox[1][1]}`
    }, function(res){
      let data = res
      data.features = res.features.map(feature => {
        let maxKey = ""
        let max = 0
        Object.keys(feature.properties).forEach(key => {
          if (feature.properties[key] && max < feature.properties[key]) {
            max = feature.properties[key]
            maxKey = key
          }
        })
        feature.properties['max'] = maxKey
        return feature
      })
      console.log(data)
      map.getSource('racedata').setData(data);
    })
  }
  const updateDataIncome = (map, bbox) => {
    let api = new ApiInterface();
    api.arcgis('https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Median_Income_by_Race_and_Age_Selp_Emp_Boundaries/FeatureServer/2/query?where=1%3D1&geometryType=esriGeometryEnvelope&outSR=4326&spatialRel=esriSpatialRelIntersects&outFields=OBJECTID,GEOID,B19049_001E&returnGeometry=true&f=pgeojson', {
      geometry: `${bbox[0][0]}, ${bbox[0][1]}, ${bbox[1][0]}, ${bbox[1][1]}`
    }, function(res){
      console.log(res)
      map.getSource('income').setData(res);
    })
  }
  const updateOccupancyData = (map, bbox) => {
    let api = new ApiInterface();
    api.arcgis('https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Household_Size_Boundaries/FeatureServer/2/query?where=1%3D1&geometryType=esriGeometryEnvelope&outSR=4326&spatialRel=esriSpatialRelIntersects&outFields=B25010_001E&returnGeometry=true&f=pgeojson', {
      geometry: `${bbox[0][0]}, ${bbox[0][1]}, ${bbox[1][0]}, ${bbox[1][1]}`
    }, function(res){
      map.getSource('occupancy').setData(res);
    })
  }

  const onZoom = (map, evt) => {
    const race = document.getElementById('race')
    const income = document.getElementById('income')
    const occupancy = document.getElementById('occupancy')
    const bbox = map.getBounds().toArray()
    const zoom = map.getZoom()
    if (!evt.fitboundUpdate && race && zoom >= 13 && zoom <= 17) {
      updateData(map, bbox)
    }
    if (!evt.fitboundUpdate && income && zoom >= 10 && zoom <= 17) {
      updateDataIncome(map, bbox)
    }
    if (!evt.fitboundUpdate && occupancy && zoom >= 10 && zoom <= 17) {
      updateOccupancyData(map, bbox)
    }
  }

  const getAncestryColors = (colors, progress) => {
    let fillColor = ['match',
      ['get', 'FirAHRName'],
      'PCT_P0020002',
      '#fb9902',
    ]
    Object.keys(colors).forEach(key => {
      fillColor.push(key);
      fillColor.push(colors[key])
    })
    fillColor.push('white')
    let res = {
      'fill-color': fillColor,
      'fill-outline-color': 'gray',
      'fill-opacity': 1*0.01*progress
    }
    return res
  }

  const getIncomeColor = (value) => {
    if (value >= 121000) {
      return "#d6a41a"
    } else if (value >= 84800) {
      return "#3a8059"
    } else if (value >= 48600) {
      return "#85bf9b"
    } else if (value >= 12400) {
      return "#8a8fbf"
    } else if (value >= 0) {
      return "#434e96"
    } 
  }

  const getOccupancyColor = (value) => {
    if (value >= 4) {
      return "#f50000"
    } else if (value >= 3) {
      return "#f53d00"
    } else if (value >= 2) {
      return "#f57a00"
    } else if (value >= 1) {
      return "#f5b800"
    } else if (value >= 0) {
      return "#f5f500"
    } 
  }

  const renderMapKey = (type) => {
    if (type == 'crime') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Crime)</div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(238, 89%, 58%)'}}></div>
          <div className='map-key-title'>Property</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(156, 76%, 43%)'}}></div>
          <div className='map-key-title'>Society</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(0, 86%, 54%)'}}></div>
          <div className='map-key-title'>Person</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(61, 77%, 54%)'}}></div>
          <div className='map-key-title'>Person Property</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: '#ffff79'}}></div>
          <div className='map-key-title'>Simple Assault</div>
        </div>
      </div>
    }
    if (type == 'ancestry') {
      let countries = Object.keys(COUNTRY_COLORS).sort()
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Ancestry)</div>
        {countries.map(cn => {
          return <div>
            <div className={`popup-header map-key-icon`} style={{backgroundColor: COUNTRY_COLORS[cn]}}></div>
            <div className='map-key-title'>{cn}</div>
          </div>
        })}
      </div>
    }
    if (type == 'race') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Race)</div>
        {Object.keys(raceLabels).map(key => {
          return <div>
            <div className={`popup-header map-key-icon ${key}`}></div>
            <div className='map-key-title'>{ raceLabels[key] }</div>
          </div>
        })}
        <div>
          <div className={`popup-header map-key-icon other`}></div>
          <div className='map-key-title'>Unreported</div>
        </div>
      </div>
    }
    if (type == 'voting') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Voting 2020)</div>
        <div>
          <div className={`popup-header map-key-icon color-blue`}></div>
          <div className='map-key-title'>Joseph Biden</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon color-red`}></div>
          <div className='map-key-title'>Donald Trump</div>
        </div>
      </div>
    }
    if (type == 'voting2024') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Voting 2024)</div>
        <div>
          <div className={`popup-header map-key-icon color-blue`}></div>
          <div className='map-key-title'>Kamala Harris</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon color-red`}></div>
          <div className='map-key-title'>Donald Trump</div>
        </div>
      </div>
    }
    if (type == 'income') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Income)</div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#d6a41a"}}></div>
          <div className='map-key-title'>&#62; $121,000</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#3a8059"}}></div>
          <div className='map-key-title'>$84,800 - $121,000</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#85bf9b"}}></div>
          <div className='map-key-title'>$48,600 - $84,800</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#8a8fbf"}}></div>
          <div className='map-key-title'>$12,400 - $48.600</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#434e96"}}></div>
          <div className='map-key-title'>&#60; $12,400</div>
        </div>
      </div>
    }
    if (type == 'occupancy') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Household Size)</div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f50000"}}></div>
          <div className='map-key-title'>&#62; 4</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f53d00"}}></div>
          <div className='map-key-title'>3 - 4</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f57a00"}}></div>
          <div className='map-key-title'>2 - 3</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f5b800"}}></div>
          <div className='map-key-title'>1 - 2</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f5f500"}}></div>
          <div className='map-key-title'>0 - 1</div>
        </div>
      </div>
    }
    return <div></div>
  }

  return (
    <div>
      {loading && <div className='icon-loading'><ReactLoading color="rgb(165, 28, 28)" type="spin"/></div>}
      {state.race?.on && <div id='race'></div>}
      {state.crime?.on && <div id='crime'></div>}
      {state.voting?.on && !state.voting2024?.on && <div id='voting'></div>}
      {state.voting?.on && state.voting2024?.on && <div id='voting2024'></div>}
      {state.ancestry?.on && <div id='ancestry'></div>}
      {state.income?.on && <div id='income'></div>}
      {state.occupancy?.on && <div id='occupancy'></div>}
      <Map
        center={center}
        zoom={zoom}
        style="mapbox://styles/mapbox/streets-v9"
        onClick = {(map, evt) => onClickMap(map, evt)}
        containerStyle={{
          height: 'calc(100vh - 0px)',
          width: '100vw'
        }}
        movingMethod="jumpTo"
        onZoomEnd={(map, event) => onZoom(map, event)}
        onMoveEnd={(map, event) => onZoom(map, event)}
        ref={mapRef}
      >
        <Source id='mapillarysdata' tileJsonSource={{
          "type": "vector",
          "tiles": ['https://peoplemaps.us/mapsdata/api/data/{z}/{x}/{y}.mvt', ]
        }} />
        <Source id='racedata' tileJsonSource={{
          "type": "geojson",
          'data': 'https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Census_2020_Redistricting_Blocks/FeatureServer/0/query?where=&geometry=-88.1518647%2C+42.3607744%2C+-87.8405116%2C+42.7723643&geometryType=esriGeometryEnvelope&inSR=4326&spatialRel=esriSpatialRelIntersects&outFields=PCT_P0020007%2C+PCT_P0020008%2C+PCT_P0020006%2C+PCT_P0020002%2C+PCT_P0020009%2C+PCT_P0020010%2C+PCT_P0020011%2C+PCT_P0020005&returnGeometry=true&f=pgeojson'
        }} />
        <Source id='income' tileJsonSource={{
          "type": "geojson",
          'data': 'https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Median_Income_by_Race_and_Age_Selp_Emp_Boundaries/FeatureServer/2/query?where=1%3D1&geometry=-88.1518647%2C+42.3607744%2C+-87.8405116%2C+42.7723643&geometryType=esriGeometryEnvelope&inSR=4326&spatialRel=esriSpatialRelIntersects&outSR=4326&outFields=OBJECTID,GEOID,B19049_001E&returnGeometry=true&f=pgeojson'
        }} />
        <Source id='occupancy' tileJsonSource={{
          "type": "geojson",
          'data': 'https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Household_Size_Boundaries/FeatureServer/2/query?where=1%3D1&geometry=-88.1518647%2C+42.3607744%2C+-87.8405116%2C+42.7723643&geometryType=esriGeometryEnvelope&outSR=4326&spatialRel=esriSpatialRelIntersects&outFields=B25010_001E&returnGeometry=true&f=pgeojson'
        }} />
        <Source id='votingdata' tileJsonSource={{
          "type": "vector",
          // "tiles": ['http://3.20.79.56:8000/api/voting/{z}/{x}/{y}.mvt', ]
          "tiles": ['http://localhost:8080/maps/voting/{z}/{x}/{y}.mvt', ]
          
        }} />
        <Source id='ancestrydata' tileJsonSource={{
          "type": "vector",
          "tiles": ['https://peoplemaps.us/mapsdata/api/ancestry/{z}/{x}/{y}.mvt', ]
        }} />
        { state.income?.on && <Layer
          id='income'
          type='fill'
          minZoom={10}
          sourceId='income'
          paint={{
            'fill-color': [
              'case',
              [">=", ["to-number", ["get", "B19049_001E"], 0],  121000],
              '#d6a41a',
              [">=", ["to-number", ["get", "B19049_001E"], 0],  84800],
              '#3a8059',
              [">=", ["to-number", ["get", "B19049_001E"], 0],  48600],
              '#85bf9b',
              [">=", ["to-number", ["get", "B19049_001E"], 0],  12400],
              '#8a8fbf',
              [">=", ["to-number", ["get", "B19049_001E"], 0],  0],
              '#434e96',
              'gray'
            ],
            'fill-opacity': 1*0.01*state.income?.progress
          }}
        /> }
        { state.occupancy?.on && <Layer
          id='occupancy'
          type='fill'
          minZoom={10}
          sourceId='occupancy'
          paint={{
            'fill-color': [
              'case',
              [">=", ["to-number", ["get", "B25010_001E"], 0],  4],
              '#f50000',
              [">=", ["to-number", ["get", "B25010_001E"], 0],  3],
              '#f53d00',
              [">=", ["to-number", ["get", "B25010_001E"], 0],  2],
              '#f57a00',
              [">=", ["to-number", ["get", "B25010_001E"], 0],  1],
              '#f5b800',
              [">=", ["to-number", ["get", "B25010_001E"], 0],  0],
              '#f5f500',
              'gray'
            ],
            'fill-opacity': 1*0.01*state.occupancy?.progress
          }}
        /> }
        { state.ancestry?.on && <Layer
          id='ancestrydata-layer'
          type='fill'
          sourceId='ancestrydata'
          sourceLayer='default'
          minZoom={10}
          maxZoom={17}
          paint={getAncestryColors(COUNTRY_COLORS, state.ancestry?.progress)}
        /> }
        { state.race?.on && <Layer
          id='racedata'
          type='fill'
          minZoom={13}
          sourceId='racedata'
          paint={{
            'fill-color': ['match',
              ['get', 'max'],
              'PCT_P0020002',
              '#fb9902',
              'PCT_P0020005',
              '#78327b',
              'PCT_P0020006',
              '#fffe32',
              'PCT_P0020007',
              '#66b132',
              'PCT_P0020008',
              '#fe2712',
              'PCT_P0020009',
              '#ff00ba',
              'PCT_P0020010',
              '#5d4900',
              'PCT_P0020011',
              '#0392ce',
              'gray'
            ],
            'fill-opacity': 1*0.01*state.race?.progress
          }}
        /> }

        { state.voting?.on && <Layer
            id='votingdata-point'
            type='fill'
            sourceId='votingdata'
            sourceLayer='default'
            minZoom={10}
            maxZoom={17}
            paint={{
              'fill-color': [
                'case',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  70],
                'blue',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  40],
                '#4444ff',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  20],
                '#7575fb',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  0],
                '#a2a2f7',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -20],
                '#ff5858',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -40],
                '#ff2929',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -70],
                '#ff1210',
                [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -100],
                'red',
                'blue'
              ],
              'fill-opacity': 1*0.01*state.voting?.progress
            }}
          />
        }

        { state.crime?.on && <Layer
          id='mapillarysdata-point'
          type='circle'
          sourceId='mapillarysdata'
          sourceLayer='default'
          minZoom={13}
          maxZoom={17}
          paint={{
            'circle-color': ['match',
              ['get', 'severity'],
              '1',
              state.crime?.property ? 'hsl(238, 89%, 58%)' : "rgba(0, 0, 255, 0)",
              '2',
              'hsl(156, 76%, 43%)',
              '3',
              'hsl(61, 77%, 54%)',
              '4',
              '#ffff79',
              '5',
              'hsl(0, 86%, 54%)',
              'red'
            ],  //need function here to get crime category
            'circle-stroke-color': 'white',
            'circle-stroke-width': 0,
            // Transition from heatmap to circle layer by zoom level
            'circle-opacity': [
                'interpolate',
                ['linear'],
                ['zoom'],
                10,
                0,
                11,
                1*0.01*state.crime?.progress
            ],
            'circle-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              11,
              2,
              14,
              4,
              16,
              6
            ]
          }}
        /> }

        <ZoomControl className="zoom-panel" position="bottom-right" />
        <ScaleControl measurement="mi" style={{
          color: 'black'
        }} className="scale-panel"/>

        {/* {isMarker && <Marker
          coordinates={center}
          anchor="bottom">
          <img src={markerUrl}/>
        </Marker>} */}

        <div>
          <div
            className={slide ? 'map-key' : 'd-none'}
          >
            { state.crime?.on && renderMapKey('crime') }
            { state.voting?.on && renderMapKey('voting') }
            { state.race?.on && renderMapKey('race') }
            { state.ancestry?.on && renderMapKey('ancestry') }
            { state.income?.on && renderMapKey('income') }
            { state.occupancy?.on && renderMapKey('occupancy') }
          </div>

          <div
           className='mapkey-open' 
          >
            {/* <MenuOutlined
              onClick={() => setSlide(!slide)}
            /> */}
            {slide ?
              <DownOutlined
                onClick={() => setSlide(!slide)}
                style={{fontSize: 30, fontWeight: 'bold'}}
              />
            :
              <UpOutlined
                onClick={() => setSlide(!slide)}
                style={{fontSize: 30, fontWeight: 'bold'}}
              />
            }
          </div>
        </div>

        <div
          className={`${!showPopup ? 'hidden': ''}`}
        >
          <Popup coordinates={popPoint}
            onClose={() => setShowPopup(false)}>
            { state.voting?.on && !state.race?.on && data && <div className={`popup-header ${data[4] > 0 ? 'color-blue' : 'color-red'}`}>
              Precinct: {data[0]}
              <button onClick={(e)=>setShowPopup(false)} className='close-btn'>X</button>
            </div>}
            { state.voting?.on && !state.race?.on && data[4] && <div className='popup-body'>
              <div>
                <span className='d-title'>Joseph Biden:</span>
                <span>{data[1]}</span>
              </div>
              <div>
                <span className='d-title'>Donald Trump:</span>
                <span>{data[2]}</span>
              </div>
              <div>
                <span className='d-title'>Total:</span>
                <span>{data[3]}</span>
              </div>
              <div>
                <span className='d-title'>Percent Dem Lead:</span>
                <span>{data[4]}%</span>
              </div>
            </div>}

            { state.crime?.on && !state.race?.on && !state.voting?.on && data[4] && <div className={`popup-header ${SERVRITY[data[16]] ? SERVRITY[data[16]] : ''}`}>
              {data[16] == "4" ? "Simple Assault" : data[9]}
              <button onClick={(e)=>setShowPopup(false)} className='close-btn'>X</button>
            </div>}
            { state.crime?.on && data[4] && !state.race?.on && !state.voting?.on && <div className='popup-body'>
              <div>
                <span className='d-title'>Incident Date:</span>
                <span>{new Date(data[4]).toLocaleString()}</span>
              </div>
              <div>
                <span className='d-title'>Incident Offense:</span>
                <span>{data[5]}</span>
              </div>
              <div>
                <span className='d-title'>Incident Offense Description:</span>
                <span>{data[7]}</span>
              </div>
              <div>
                <span className='d-title'>Incident Offense Detail Description:</span>
                <span>{data[8]}</span>
              </div>
              <div>
                <span className='d-title'>Incident Offense Crime Against:</span>
                <span>{data[9]}</span>
              </div>
              <div>
                <span className='d-title'>Incident Offense Action:</span>
                <span>{data[10]}</span>
              </div>
              <div>
                <span className='d-title'>Incident Source Name:</span>
                <span>{data[12]}</span>
              </div>
              <div>
                <span className='d-title'>Incident Address:</span>
                <span>{data[15]}</span>
              </div>
            </div>}
            { state.race?.on && currZoom >= 13 && currZoom <= 17 && data['max'] && <div className={`popup-race popup-header ${data['max'] ? data['max'] : ''}`}>
              {raceLabels[data['max']]}
              <button onClick={(e)=>setShowPopup(false)} className='close-btn'>X</button>
            </div>}
            { state.race?.on && data['max'] && currZoom >= 13 && currZoom <= 17 && <div className='popup-body race-body'>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020002']}:</span>
                <span>{data['PCT_P0020002']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020005']}:</span>
                <span>{data['PCT_P0020005']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020006']}:</span>
                <span>{data['PCT_P0020006']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020007']}:</span>
                <span>{data['PCT_P0020007']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020008']}:</span>
                <span>{data['PCT_P0020008']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020009']}:</span>
                <span>{data['PCT_P0020009']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020010']}:</span>
                <span>{data['PCT_P0020010']}</span>
              </div>
              <div>
                <span className='d-title'>{raceLabels['PCT_P0020011']}:</span>
                <span>{data['PCT_P0020011']}</span>
              </div>
            </div>}


            { state.ancestry?.on && !state.race?.on && !state.voting?.on && !state.crime?.on && data[3] && <div className={`popup-race popup-header`} style={{backgroundColor: COUNTRY_COLORS[data[3]]}}>
              {data[0]}
              <button onClick={(e)=>setShowPopup(false)} className='close-btn'>X</button>
            </div>}
            { state.ancestry?.on && !state.race?.on && !state.voting?.on && !state.crime?.on && data[3] && <div className='popup-body race-body'>
              <div>
                <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data[3]]}}></span>
                <span className='d-title'>{data[3]}:</span>
                <span>{(data[2] * 100).toFixed(1)}%</span>
              </div>
              <div>
                <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data[6]]}}></span>
                <span className='d-title'>{data[6]}:</span>
                <span>{(parseFloat(data[7]) * 100).toFixed(1)}%</span>
              </div>
              <div>
                <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data[10]]}}></span>
                <span className='d-title'>{data[10]}:</span>
                <span>{(parseFloat(data[11]) * 100).toFixed(1)}%</span>
              </div>
              <div>
                <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data[14]]}}></span>
                <span className='d-title'>{data[14]}:</span>
                <span>{(parseFloat(data[15]) * 100).toFixed(1)}%</span>
              </div>
              <div>
                <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data[18]]}}></span>
                <span className='d-title'>{data[18]}:</span>
                <span>{(parseFloat(data[19]) * 100).toFixed(1)}%</span>
              </div>
              <div>
                <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data[22]]}}></span>
                <span className='d-title'>{data[22]}:</span>
                <span>{(parseFloat(data[23]) * 100).toFixed(1)}%</span>
              </div>
            </div>}


            { state.income?.on && !state.ancestry?.on && !state.race?.on && !state.voting?.on && !state.crime?.on && data['B19049_001E'] && <div className={`popup-race popup-header`} style={{backgroundColor: getIncomeColor(data['B19049_001E'])}}>
              Median Household Income (2020)
              <button onClick={(e)=>setShowPopup(false)} className='close-btn'>X</button>
            </div>}
            { state.income?.on && !state.ancestry?.on && !state.race?.on && !state.voting?.on && !state.crome?.on && data['B19049_001E'] && <div className='popup-body race-body'>
              <div>
                <span className='d-title'>Median Income:</span>
                <span>{parseFloat(data['B19049_001E']).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}</span>
              </div>
            </div>}

            { state.occupancy?.on && !state.income?.on && !state.ancestry?.on && !state.race?.on && !state.voting?.on && !state.crime?.on && data['B25010_001E'] && <div className={`popup-race popup-header`} style={{backgroundColor: getOccupancyColor(data['B25010_001E'])}}>
              Household Size
              <button onClick={(e)=>setShowPopup(false)} className='close-btn'>X</button>
            </div>}
            { state.occupancy?.on && !state.income?.on && !state.ancestry?.on && !state.race?.on && !state.voting?.on && !state.crome?.on && data['B25010_001E'] && <div className='popup-body race-body'>
              <div>
                <span className='d-title'>Size:</span>
                <span>{data['B25010_001E']}</span>
              </div>
            </div>}
          </Popup>
        </div>
      </Map>
    </div>
  );
}

export default MapContainer;
